import * as api from '../../api'
import * as userActions from '../actions/user'

export const getAddresses = () => dispatch => {
  dispatch(userActions.getAddresses())
  return api
    .getAddresses()
    .then(res => dispatch(userActions.getAddressesSuccess(res.data.addresses)))
    .catch(err => dispatch(userActions.getAddressesFail(err)))
}

export const createAddress = address => dispatch => {
  dispatch(userActions.createAddress())
  return api
    .createAddress(address)
    .then(res => {
      if (res.errors) {
        dispatch(userActions.createAddressFail(res.errors))
        return { success: false, error: res.errors[0].message }
      }
      dispatch(userActions.createAddressSuccess(res.data.saveAddress))

      return { success: true }
    })
    .catch(error => {
      dispatch(userActions.createAddressFail(error))
      return { success: false, error: error.graphQLErrors[0].message }
    })
}

export const updateAddress = address => dispatch => {
  dispatch(userActions.updateAddress())
  return api
    .updateAddress(address)
    .then(res => {
      if (res.errors) {
        dispatch(userActions.updateAddressFail(res.errors))
        return { success: false, error: res.errors[0].message }
      }
      dispatch(userActions.updateAddressSuccess(res.data.saveAddress))
      return { success: true }
    })
    .catch(error => {
      dispatch(userActions.updateAddressFail(error))
      return { success: false, error: error.graphQLErrors[0].message }
    })
}

export const removeAddress = id => dispatch => {
  dispatch(userActions.removeAddress())
  return api
    .removeAddress(id)
    .then(res =>
      dispatch(
        userActions.removeAddressSuccess(res.data.removeAddress.addresses)
      )
    )
    .catch(err => dispatch(userActions.removeAddressFail(err)))
}

export const getCards = () => dispatch => {
  dispatch(userActions.getCards())
  return api
    .getCards()
    .then(res => dispatch(userActions.getCardsSuccess(res.data.cards)))
    .catch(err => dispatch(userActions.getCardsFail(err)))
}

export const createCard = card => dispatch => {
  dispatch(userActions.createCard())
  return api
    .createCard(card)
    .then(res => {
      if (res.errors) {
        dispatch(userActions.createCardFail(res.errors))
        return { success: false, error: res.errors[0].message }
      }
      dispatch(userActions.createCardSuccess(res.data.addCard))
      return { success: true }
    })
    .catch(error => {
      dispatch(userActions.createCardFail(error))
      return { success: false, error: error.graphQLErrors[0].message }
    })
}

export const removeCard = id => dispatch => {
  dispatch(userActions.removeCard())
  return api
    .removeCard(id)
    .then(res =>
      dispatch(userActions.removeCardSuccess(res.data.removeCard.cards))
    )
    .catch(err => dispatch(userActions.removeCardFail(err)))
}

export const getUserInfo = () => dispatch => {
  dispatch(userActions.getUserInfo())
  return api
    .getUserInfo()
    .then(res => dispatch(userActions.getUserInfoSuccess(res.data.profile)))
    .catch(err => dispatch(userActions.getUserInfoFail(err)))
}



// WEBPACK FOOTER //
// ./src/store/effects/user.js